import React from 'react';
import {
  MemoryRouter,
  Route,
  Routes as BrowserRoutes,
} from 'react-router-dom';
import 'react-router-dom';

//Pages
import Risco from './pages/risco';
import Tutorial from './pages/tutorial';
import Sobre from './pages/sobre';
import SideBar from './common/template/sideBar';

const Page = ({ children }) => {
  return (
    <div className='wrapper'>
      <SideBar />
      {children}
    </div>
  );
};

const Routes = () => (
  <MemoryRouter>
    <BrowserRoutes>
      <Route
        path='/'
        element={
          <Page>
            <Risco />
          </Page>
        }
      />
      <Route
        path='/tutorial'
        element={
          <Page>
            <Tutorial />
          </Page>
        }
      />
      <Route
        path='/sobre'
        element={
          <Page>
            <Sobre />
          </Page>
        }
      />      
      <Route
        path='/risco'
        element={
          <Page>
            <Risco />
          </Page>
        }
      />
      <Route
        path='*'
        element={
          <Page>
            <Risco />
          </Page>
        }
      />
    </BrowserRoutes>
  </MemoryRouter>
);

export default Routes;
